import { NgModule } from '@angular/core';
import { B2bCommonModule } from '@siko/shared/b2b-common.module';
import { SikoRemoveCartEntryComponent } from './remove-cart-entry.component';
import { SikoDialogComponentsModule } from '@siko/features/shared-components/dialog-components/dialog-components.module';
import { SikoButtonComponent } from '@siko/components/atomic';


@NgModule({
    declarations: [
        SikoRemoveCartEntryComponent,
    ],
    imports: [
        B2bCommonModule,
        SikoDialogComponentsModule,
        SikoButtonComponent
    ],
})
export class SikoRemoveCartEntryModule {
}
